import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';

const handleError = (error: Error) => {
  if (error instanceof AxiosError) {
    toast.error(error.response?.data?.error || error.message);
  }
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleError }),
  mutationCache: new MutationCache({ onError: handleError }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Don't refetch when user returns to tab
      refetchOnMount: false, // Don't refetch when component remounts
      retry: false, // Don't retry failed requests
      gcTime: Infinity, // Never garbage-collect cached data
      staleTime: Infinity, // Cached data is always considered fresh
    },
  },
});
